/**
 * Action creator for creating an account.
 *
 * Body is the full formatted values object (no diff) — matches the
 * legacy AccountCreate submit flow. Caller is responsible for
 * running values through `formattedAccountsValues` before handing
 * them in, same as in the legacy component.
 *
 * Endpoint: PUT /accounts
 */
export const createAccountAction = ({ values }) => ({
  method: 'PUT',
  endpoint: '/accounts',
  body: values,
});
